/* Soulskart how-we-print — video facade.

   A YouTube iframe pulls roughly a megabyte of third-party JavaScript on page
   load whether or not anyone presses play, and on a page whose whole job is to
   be watched that cost lands on every visitor including the ones who scroll
   past. So the section renders a poster and a play button, and this swaps in
   the real iframe on the first click.

   autoplay=1 is on the swapped-in URL because the click WAS the play action —
   without it the shopper has to press play twice.

   youtube-nocookie.com, so nobody who never presses play gets a tracking
   cookie from a page they only scrolled. */
(() => {
  if (window.__ssProcess) return;
  window.__ssProcess = true;

  document.addEventListener('click', (e) => {
    const btn = e.target.closest ? e.target.closest('[data-ss-video-play]') : null;
    if (!btn) return;

    const wrap = btn.closest('[data-ss-video]');
    if (!wrap) return;

    const id = (wrap.getAttribute('data-ss-video') || '').trim();
    if (!id) return;

    e.preventDefault();

    const frame = document.createElement('iframe');
    frame.className = 'skpr__frame';
    frame.src =
      'https://www.youtube-nocookie.com/embed/' +
      encodeURIComponent(id) +
      '?autoplay=1&rel=0&playsinline=1&modestbranding=1';
    frame.title = btn.getAttribute('aria-label') || 'Process film';
    frame.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; web-share';
    frame.setAttribute('allowfullscreen', '');
    frame.setAttribute('loading', 'eager');

    wrap.textContent = '';
    wrap.appendChild(frame);
    wrap.classList.add('is-playing');
    frame.focus();
  });
})();
